import {
  Alert,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import {
  getPaymentTypeLabel,
  IOrderInfoPaymentTransaction,
} from '../utils/types';
import { formatAmountInCurrency } from '../utils';

type OrderInfoPaymentTransactionProps = {
  paymentTransaction?: IOrderInfoPaymentTransaction;
};

export default function OrderInfoPaymentTransaction({
  paymentTransaction,
}: OrderInfoPaymentTransactionProps) {
  const { t } = useTranslation();
  const totalPayment =
    paymentTransaction?.paymentTransactions.reduce(
      (acc, curr) => acc + Number(curr.amount),
      0,
    ) || 0;

  if (totalPayment === 0)
    return <Typography>{t('orderInfos.noPayment')}</Typography>;

  const currencyCode =
    paymentTransaction?.paymentTransactions[0].currency.code || '';

  return (
    <Box>
      {paymentTransaction &&
        paymentTransaction.paymentTransactions.length > 0 && (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    {t('orderInfos.transactionType')}
                  </TableCell>
                  <TableCell padding={'none'} align="center">
                    {t('orderInfos.transactionDate')}
                  </TableCell>
                  <TableCell align="left">
                    {t('orderInfos.transactionDescription')}
                  </TableCell>
                  <TableCell align="right">
                    {t('orderInfos.transactionAmount')}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paymentTransaction?.paymentTransactions.map(
                  (paymentTransactionItem) => (
                    <TableRow key={paymentTransactionItem.erpTransactionNumber}>
                      <TableCell>
                        {getPaymentTypeLabel(
                          paymentTransactionItem.paymentType,
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {format(paymentTransactionItem.date, 'dd.MM.yyyy')}
                      </TableCell>
                      <TableCell>
                        {paymentTransactionItem.description}
                      </TableCell>
                      <TableCell align="right">
                        {formatAmountInCurrency(
                          Number(paymentTransactionItem.amount),
                          paymentTransactionItem.currency.code,
                        )}
                      </TableCell>
                    </TableRow>
                  ),
                )}
                <TableRow sx={{ td: { fontWeight: 'bold', fontSize: '1rem' } }}>
                  <TableCell>{t('orderInfos.totalAmount')}</TableCell>
                  <TableCell align="right" colSpan={3}>
                    {formatAmountInCurrency(totalPayment, currencyCode)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
    </Box>
  );
}
